import { useState, useEffect } from 'react';
import './Style.css';
import download from './icons/file-download.svg';
import data from './icons/getData.svg';
import filter from './icons/filter.svg';
import SideSlidePanel from './SideSlidePanel.js';
import './SideSlidePanel.css';
import Profile from './icons/Profile.png';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

function Datepicker({ onSearch, onDataExport, DATA, onDateSelect ,handleFilterChange, changedData}) {
  const [isValid, setIsValid] = useState(true);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const location = useLocation();
  const username = location.state?.username || '';

  
  useEffect(() => {
    // Set default values for fromDate and toDate when component mounts
    const currentDate = new Date();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

    const formatDateString = (date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const defaultFromDate = formatDateString(firstDayOfMonth);
    const defaultToDate = formatDateString(currentDate);

    setFromDate(defaultFromDate);
    setToDate(defaultToDate);

    // Assuming onDateSelect is a function to handle date selection
    // You can replace this with your actual function
    //onDateSelect(defaultFromDate, defaultToDate);
  }, []);
  

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
    setIsValid(event.target.value <= toDate);

      // Invoke the callback with the selected dates
      //onDateSelect(event.target.value, toDate);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
    setIsValid(fromDate <= event.target.value);

    // Invoke the callback with the selected dates
    //onDateSelect(fromDate, event.target.value);

  };

  const handleAjaxCall = async () => {
    try {
      await onDateSelect(fromDate, toDate);  // Wait for the AJAX call to complete
    } catch (error) {
      console.error('Error:', error);  // Handle any potential errors
    }
  };

  const handleSearchChange = (e) => {
    const newSearchQuery = e.target.value;
    onSearch(newSearchQuery); // Pass the search query to the parent component
  };

  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const openPanel = () => {
    setIsPanelOpen(true);
  };

  const closePanel = () => {
    setIsPanelOpen(false);
  };

  const JSONToCSV = (data) => {
    const headers = Object.keys(data[0]);
    const csvContent =
      'data:text/csv;charset=utf-8,' +
      headers.join(',') +
      '\n' +
      data.map((row) => headers.map((header) => row[header]).join(',')).join('\n');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'Employee-data.csv');
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div className='table-container'>
      <div className='container'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '50px',
          }}
        >
          <h2
            style={{
              color: '#1DA1F2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              paddingLeft:"15px"
            }}
          >
            Attendance Report
          </h2>{' '}
          <div style={{ display: 'flex', alignItems: 'center' , paddingRight:"20px"}}>
            <img
              src={Profile}
              alt=""
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                paddingRight: '10px',
              }}
            />
            <span>{username.toUpperCase()}</span>
          </div>
        </div>
        <hr />
        <div className='c1'>
          <div className='search'>
            <input
              type='text'
              placeholder='Search Name'
              className='wider-search-bar'
              onChange={handleSearchChange}
            />
          </div>
          <div className='datepicker'>
            <input
              type='date'
              className='datepicker-body'
              value={fromDate}
             onChange={handleFromDateChange}
            />
            <input
              type='date'
              className='datepicker-body'
              value={toDate}
             onChange={handleToDateChange}
            />

          <button 
            className="custom-button button-get-result"
            type="button" 
            onClick={handleAjaxCall}
    
          >
          <img 
              src={data} alt="data" style={{height: "37px"}} />
          <span>Get Data</span>
          </button>
            <p className='valid' style={{ color: isValid ? 'black' : 'red' }}>
              {isValid ? '' : 'Invalid Date.'}
            </p>
          </div>
          <div className='filter'>
            <div className='Datepicker'>
              <button className='custom-button button-filter' onClick={openPanel}>
                <span>Filter</span>
                <img alt="" src={filter} className='' style={{height: "25px"}} />
              </button>
              <SideSlidePanel isOpen={isPanelOpen} onClose={closePanel} handleFilterChange={handleFilterChange} />
            </div>
            <button
              className='custom-button'
              onClick={() => changedData && JSONToCSV(changedData)}
            >
              <img src={download} alt="" className='' style={{ height: "49px", width: "47px" }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

Datepicker.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onDataExport: PropTypes.func,
  DATA: PropTypes.array,
  onDateSelect: PropTypes.func.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  changedData: PropTypes.array
};
export default Datepicker;
